'use strict';

define('lib/helpers/trimString',['Handlebars'], function (Handlebars) {
  Handlebars.registerHelper('trimString', function (passedString) {
    var theString = passedString;
    if (theString.length > 165) {
      theString = theString.substring(0, 161) + '...';
    }
    return new Handlebars.SafeString(theString)
  });
});

